import Vue from 'vue'
import App from './App.vue'
import store from "@/vuex/store";
import router from "@/router";
import DataTable from "@andresouzaabreu/vue-data-table";
import "bootstrap/dist/css/bootstrap.min.css";
import "@andresouzaabreu/vue-data-table/dist/DataTable.css";
import "vue-select/dist/vue-select.css";
import VueSimpleAlert from "vue-simple-alert";
import axios from "axios";
import VueAxios from 'vue-axios'
import vSelect from "vue-select";
import setupInterceptors from './services/setupInterceptors';
// You need a specific loader for CSS files
import VueMoment from 'vue-moment'
import 'vue-phone-number-input/nuxt/plugin';

Vue.use(VueMoment)

Vue.config.productionTip = false;
Vue.prototype.$tzoffset = 10800000;
Vue.use(VueSimpleAlert);
// axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.access_token;
Vue.use(VueAxios, axios)
Vue.component("data-table", DataTable);

Vue.component("v-select", vSelect);
setupInterceptors(store);


new Vue({
    store, router,
    render: h => h(App)
}).$mount('#app')
